import { Address } from '@shared/types'
import { JSX } from 'react'

import { DomesticAddressFields } from './DomesticAddressFields'
import { ForeignAddressFields } from './ForeignAddressFields'

export interface AddressProps {
  address: Address
  showCountry?: boolean
}

export const AddressFields = ({ address, showCountry = true }: AddressProps): JSX.Element => {
  if (address.domesticAddress) {
    return <DomesticAddressFields address={address.domesticAddress} showCountry={showCountry} />
  }
  if (address.foreignAddress) {
    return <ForeignAddressFields address={address.foreignAddress} />
  }
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <></>
}
